/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SuccessData } from "./SuccessData";
export const Success = core.serialization.object({
    data: SuccessData.optional(),
});
